import React from "react";
import { string, node, oneOfType, arrayOf, objectOf, number } from "prop-types";
import cx from "classnames";
import { findByType } from "../util/findByType";
import { isChildType } from "../util/isChildType";
// eslint-disable-next-line import/no-cycle
import { CardImage as Image } from "./Image/CardImage";
import { CardHeader as Header } from "./Header/CardHeader";
import { CardSubheader as Subheader } from "./Subheader/CardSubheader";
import { CardContent as Content } from "./Content/CardContent";
// eslint-disable-next-line import/no-cycle
import { CardLink as Link } from "./Link/CardLink";
// eslint-disable-next-line import/no-cycle
import { CardButton as Button } from "./Button/CardButton";
import { CardBodyContainer as BodyContainer } from "./BodyContainer/CardBodyContainer";
import { CardOverlay as Overlay } from "./Overlay/CardOverlay";

import * as styles from "./Card.module.scss";

const Card = ({ children, style, className }) => {
	const renderChildren = _children =>
		React.Children.map(_children, child => {
			if (isChildType(child, Overlay)) {
				return null;
			}
			if (isChildType(child, Image)) {
				const overlayComponent = findByType(_children, Overlay);
				return React.cloneElement(child, { overlay: overlayComponent });
			}
			return child;
		});

	return (
		<div className={cx(styles.cardContainer, className)} style={style}>
			{renderChildren(children)}
		</div>
	);
};
Card.displayName = "Card";

Card.Image = Image;
Card.Header = Header;
Card.Subheader = Subheader;
Card.Overlay = Overlay;
Card.Content = Content;
Card.Link = Link;
Card.Button = Button;
Card.BodyContainer = BodyContainer;

Card.propTypes = {
	children: oneOfType([arrayOf(node), node]).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
};

Card.defaultProps = {
	className: "",
	style: {},
};

export default Card;
export { Card };
